import * as React from 'react';

import {useForm} from './FormProvider';

import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { Controller } from "react-hook-form"


export default function FormDropDown({name,label,list,required,rules = {},menuItemProps = {},fullWidth,...props}) {

    const {control, errors, defaultRules } = useForm();

    const requiredDefaultRule = (required) ? {required: defaultRules['required']} : {};
    rules = {...requiredDefaultRule,...rules};

    fullWidth = (fullWidth === undefined) ? true : fullWidth;

    const labelId = name + "-label";

    return (
        <Controller
            render={({field: {onChange, value, onBlur}}) =>(
                <FormControl fullWidth={fullWidth} error={(errors[name]) ? true : false}>
                    <InputLabel id={labelId} required={required}>{label}</InputLabel>
                    <Select
                        onBlur={onBlur}
                        labelId={labelId}
                        label={label}
                        required={required}
                        value={value}
                        onChange={(event)=>{
                            onChange(event.target.value);
                        }}
                        {...props}
                    >
                        {list.map((cur)=>(<MenuItem key={cur.value || cur.label} value={cur.value || cur.label} {...menuItemProps}>{cur.label}</MenuItem>))}
                    </Select>
                    {errors[name] && <FormHelperText>{errors[name]?.message}</FormHelperText>}
                </FormControl>
            )}
            name={name}
            control={control}
            rules={rules}
        />
    );
};